export enum WindowSize {
  SMALL,
  MEDIUM,
  LARGE
}

export const BREAKPOINTS = {
  [WindowSize.SMALL]: 1274,
  [WindowSize.MEDIUM]: 1600
};

export interface WindowSizeChangeEvent {
  previous: WindowSize;
  current: WindowSize;
}

